const QueryParams = window.location.search
	.slice(1)
	.split('&')
	.map(p => p.split('='))
	.reduce((obj, [key, value]) => ({...obj, [key]: value}), {});

export default QueryParams;